import { render, staticRenderFns } from "./EachTownStreetConstructionByWelfareCentreNumber.vue?vue&type=template&id=3c8a01c4&scoped=true&"
import script from "./EachTownStreetConstructionByWelfareCentreNumber.vue?vue&type=script&lang=js&"
export * from "./EachTownStreetConstructionByWelfareCentreNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8a01c4",
  null
  
)

export default component.exports